<!-- 投诉列表 -->
<template>
  <div class="container">
    <header class="header">
      <el-radio v-model="radio" label="1">客户发起的投诉</el-radio>
      <el-radio v-model="radio" label="2">我发起的投诉</el-radio>
    </header>
    <div class="center">
      <div style="margin-bottom: 0.1rem" class="centerBox">
        <p>订单编号</p>
        <el-input
          style="width: 1.5rem; margin-right: 0.1rem"
          size="small"
          v-model="input"
          placeholder="订单编号"
        ></el-input>
        <p>资源名称</p>
        <el-input
          style="width: 1.5rem; margin-right: 0.1rem"
          size="small"
          v-model="input"
          placeholder="资源名称"
        ></el-input>
        <p>评价时间</p>
        <el-date-picker
          style="margin-right: 0.1rem;"
          size="small"
          v-model="value"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
        <p>投诉时间</p>
        <el-date-picker
          style="margin-right: 0.1rem"
          size="small"
          v-model="value"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </div>
      <div class="centerBox">
        <p>买家昵称</p>
        <el-input
          style="width: 1.5rem; margin-right: 0.1rem"
          size="small"
          v-model="input"
          placeholder="买家昵称"
        ></el-input>
        <el-checkbox-group v-model="checkList">
          <el-checkbox label="待处理"></el-checkbox>
          <el-checkbox label="处理中"></el-checkbox>
          <el-checkbox label="已处理"></el-checkbox>
        </el-checkbox-group>
        <div style="margin-left: auto">
          <el-button style="color: #fff; background-color: #e69c37" size="small"
            >搜索</el-button
          >
          <el-button size="small">重置</el-button>
        </div>
      </div>
    </div>
    <footer class="footer">
      <el-radio-group v-model="radio2" size="small">
        <el-radio-button
          v-for="item in radio2List"
          :key="item"
          :label="item"
        ></el-radio-button>
      </el-radio-group>
      <div class="right">
        <el-button size="small">申请平台协助</el-button>
      </div>
    </footer>
    <el-table
      :data="tableData"
      :header-cell-style="{ color: '#000' }"
      @selection-change="handleSelectionChange"
      style="width: 100%"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column prop="date" label="订单编号"> </el-table-column>
      <el-table-column prop="date" label="商品类型"> </el-table-column>
      <el-table-column prop="date" label="商品信息"> </el-table-column>
      <el-table-column prop="date" label="评价时间"> </el-table-column>
      <el-table-column prop="date" label="评价内容"> </el-table-column>
      <el-table-column prop="date" label="评价图片"> </el-table-column>
      <el-table-column prop="date" label="评价视频"> </el-table-column>
      <el-table-column prop="date" label="回复人"> </el-table-column>
      <el-table-column prop="date" label="投诉时间"> </el-table-column>
      <el-table-column prop="date" label="当前状态"> </el-table-column>
      <el-table-column prop="date" label="说明"> </el-table-column>
      <el-table-column prop="date" label="操作"> </el-table-column>
    </el-table>
   <Pagination></Pagination>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination.vue";

export default {
    components: {
    Pagination
  },
  data() {
    return {
      tableData: [{}],
      checkList: [],
      input: "",
      value: "",
      radio2: "全部",
      radio2List: ["全部", "自己负责的", "供应商负责的"],
      radio: "客户发起的评价",
    };
  },
  computed: {},
  watch: {},
  methods: {
    handleSelectionChange() {},
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.container {
  .header {
    margin-bottom: 0.2rem;
  }
  .center {
    padding: 0.2rem;
    background-color: #f1f1f1;
    margin-bottom: 0.2rem;
    p {
      margin-right: 0.1rem;
    }
    .centerBox {
      display: flex;
      align-items: center;
    }
  }
  .footer {
    display: flex;
    align-items: center;
    margin-bottom: 0.2rem;
    .right {
      margin-left: auto;
    }
  }
}
</style>
